const typography = {
    TITLE: "Title",
    AUTHOR: "Author",
    DESCRIPTION: "Description",
    CONTENT_TYPE: "Type",
    STATE: "State",
    ACTIVITY_SLOT: "Replaces",
    DURATION: "Duration",
    ACTION: "Action",
    SEARCH: "Search",
    ALL: "All",
    AUDIO: "Audio",
    VIDEO: "Video",
    CALM: "Calm",
    FOCUS: "Focus",
    CLARITY: "Clarity",
    ENERGY: "Energy",
    COMFORT: "Comfort",
    ADD_CONTENT: "Add Content",
    MANAGE_LOCKED_SESSIONS: "Manage Activity",
    UPLOAD_VIDEO: "Upload Video",
    EDIT_CONTENT: "Edit Content",
    VIEW_CONTENT: "View Content",
    FILE: "File",
    CHOOSE_FILE: "Choose an audio or video file",
    UPLOADING: "Uploading…",
    TEACHER_GUIDE_VIDEO: "Teacher Preview Video",
    TEACHER_GUIDE_VIDEO_HELP: "Shown to teachers on the activity preview screen before they run this with their class — optional",
    THUMBNAIL: "Thumbnail",
    THUMBNAIL_HELP: "Shown on the activity card and preview screen — leave blank to auto-generate one from the video (VIDEO content only; required for AUDIO if you want a thumbnail at all)",
    REMOVE: "Remove",
    NOT_UPLOADED: "Not uploaded",
    GOAL: "Goal",
    GOAL_HELP: "A short, one-line summary of what this activity helps with — shown on the activity preview screen",
    TEACHER_INSTRUCTIONS: "Teacher Instructions",
    TEACHER_INSTRUCTIONS_HELP: "Notes for the teacher on how to run this with their class — shown on the activity preview screen",
    STATUS: "Status",
    STATUS_ACTIVE: "Active",
    STATUS_BIN: "Bin",
    DELETE_CONFIRM_HEADING: "Move this content to the bin?",
    DELETE_CONFIRM_YES: "Delete",
    DELETING: "Deleting…",
    RESTORE: "Restore",
    PERMANENTLY_DELETE: "Delete Forever",
    PERMANENT_DELETE_CONFIRM_HEADING: "Permanently delete this content? This can't be undone.",
    PERMANENT_DELETE_CONFIRM_YES: "Delete Forever",
    EDIT_LOCKED_SESSION: "Edit Activity",
    TITLE_HELP:
        "The name teachers see on the activity card. Leave blank to keep the built-in name — this renames the card only, it cannot change which session it opens",
    DEFAULT_TITLE: "Default name",
    CUSTOM_TITLE: "Renamed",
    MUSIC: "Music",
    SUMMARY: "Card line",
    SUMMARY_HELP: "One short line under the name on the activity card",
    TIP_FOR_TEACHERS: "Tip for Teachers",
    TIP_FOR_TEACHERS_HELP: "Shown beside the Teacher Preview, before the teacher starts",
    TEACHER_INSTRUCTIONS_STEPS_HELP: "One step per line — each line becomes a bullet on the activity preview screen",
    RESET_TITLE_HELP: "The name teachers see on the activity card, preview and player. Renames the activity only — what it does cannot change",
    BACKGROUND_MUSIC: "Background Music",
    BACKGROUND_MUSIC_HELP: "Plays softly on a loop under the spoken guide while the activity runs. Teachers can turn it off from the player",
    MUSIC_VOLUME: "Volume",
    MUSIC_ENABLED: "Play background music",
    DEFAULT_ASSET: "Default",
    UPLOADED_ASSET: "Uploaded",
    RESTORE_DEFAULT: "Use default",
    REQUIRED: "Required",
    BUILT_IN_RESET: "Built-in reset",
    MUSIC_ON: "On",
    MUSIC_OFF: "Off",
};

export default typography;
